export default (incomingBlock, editor) => {
  const incomingBlockNodes = incomingBlock.nodes.toArray();

  // get focus text
  const {
    value: {
      focusText: { key: focusTextKey },
    },
  } = editor;

  // iterate through the incoming block nodes
  incomingBlockNodes.forEach((node) => {
    // get leaves of the node
    const nodeLeaves = node.getLeaves();

    if (nodeLeaves.size) {
      // iterate through the leaves
      nodeLeaves.forEach((leaf) => {
        // get offset of the focus text
        const {
          value: {
            selection: {
              anchor: { offset },
            },
          },
        } = editor;

        // insert the text node
        editor.insertTextByKey(
          focusTextKey,
          offset,
          leaf.text,
          leaf.marks ? leaf.marks : null,
        );
      });
    }
  });
};
